import script from "./ClockifyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ClockifyButton.vue?vue&type=script&setup=true&lang=js"

import "./ClockifyButton.vue?vue&type=style&index=0&id=732577f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732577f8"]])

export default __exports__